<header>
  <app-header [authenticated]="authenticated()"></app-header>
</header>
<div class="flex" style="height: calc(100% - 6.625rem);">
  @if (authenticated()) {
    <app-left-sidebar class="overflow-y-auto shrink-0 border-r border-surface-300 dark:border-surface-700"></app-left-sidebar>
  }
  <main class="w-full relative">
    <!--This is to avoid reload during acquireTokenSilent() because of hidden iframe -->
    @if (!isIframe) {
      <p-blockui [blocked]="loading() && !authenticated() && !isLogoutPage" />
      <p-blockui [target]="content" [blocked]="authenticated() && loading()" />
      <p-panel #content class="content" [ngClass]="{'hidden': showHelp()}" class="bg-surface-100 dark:bg-surface-900 h-full border-0 rounded-none main-content-panel">
        <ng-template #header>
          <div class="flex items-center gap-3 w-full">
            <h1 class="page-title text-lg text-surface-500 whitespace-nowrap">{{pageTitle()}}</h1>
            @if (showFacility()) {
              <app-facility-select />
            }
            @if (pageActions(); as actions) {
              <div class="ml-auto mr-6 flex items-center gap-6">
                <ng-container [ngTemplateOutlet]="actions" />
              </div>
            }
          </div>
        </ng-template>
        <div style="scrollbar-gutter: stable;" class="h-full overflow-y-auto flex flex-col px-4">
          <router-outlet></router-outlet>
          <p-toast position="center" key="center"/>
        </div>
        
      </p-panel>
      @if (loading()) {
        <div style="z-index:1200" class="absolute left-0 right-0 top-0 bottom-0 flex justify-center items-center">
          <p-progress-spinner ariaLabel="loading" />
        </div>
      }
    }
  <p-toast position="top-right" key="main"/>
  @if (showHelp()) {
    <app-help-overlay class="absolute left-0 top-0 right-0 bottom-0"></app-help-overlay>
  }
  </main>
  
</div>
<footer class="flex-initial border-t border-surface-300 dark:border-surface-700 dark:bg-surface-950">
  <app-footer class="m-2 text-center block"></app-footer>
</footer>
